(function () {
  const SYNC_SOURCE = 'free-gift-sync';
  let syncInProgress = false;
  let syncQueued = false;

  function getConfig() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return null;

    const isEuMarket = cartDrawer.dataset.isEuMarket === 'true';
    const threshold = parseFloat(cartDrawer.dataset.giftThreshold);
    const freeGiftId = cartDrawer.dataset.freeGiftId || '';
    const freeGiftName = cartDrawer.dataset.freeGiftName || '';

    return {
      isEuMarket,
      thresholdCents: Number.isNaN(threshold) ? null : Math.round(threshold * 100),
      freeGiftId: String(freeGiftId),
      freeGiftName,
    };
  }

  function getCurrentGiftAttributes(cart) {
    const attributes = cart.attributes || {};

    return {
      freeGift: attributes._free_gift || '',
      freeGiftId: attributes._free_gift_id ? String(attributes._free_gift_id) : '',
    };
  }

  function hasGiftAttributes(cart) {
    const current = getCurrentGiftAttributes(cart);
    return Boolean(current.freeGift || current.freeGiftId);
  }

  function attributesNeedUpdate(config, cart, thresholdMet) {
    const current = getCurrentGiftAttributes(cart);

    if (!config.isEuMarket) {
      return hasGiftAttributes(cart);
    }

    if (thresholdMet) {
      return current.freeGift !== config.freeGiftName || current.freeGiftId !== config.freeGiftId;
    }

    return hasGiftAttributes(cart);
  }

  async function fetchCart() {
    const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`);
    return response.json();
  }

  async function updateCartAttributes(attributes) {
    const response = await fetch(`${window.routes?.cart_update_url || '/cart/update'}`, {
      ...fetchConfig(),
      body: JSON.stringify({ attributes }),
    });

    return response.json();
  }

  async function syncCartFreeGiftAttributes(cartData) {
    if (syncInProgress) {
      syncQueued = true;
      return cartData;
    }

    const config = getConfig();
    if (!config) return cartData;

    // Non-EU: only clear leftover attrs; never set them.
    // EU: need threshold + gift product to set attrs.
    if (config.isEuMarket && (config.thresholdCents === null || !config.freeGiftId)) {
      return cartData;
    }

    syncInProgress = true;

    try {
      const cart = cartData && typeof cartData.total_price !== 'undefined' ? cartData : await fetchCart();
      const thresholdMet =
        config.isEuMarket &&
        cart.item_count > 0 &&
        cart.total_price >= config.thresholdCents;

      if (!attributesNeedUpdate(config, cart, thresholdMet)) {
        return cart;
      }

      const attributes =
        config.isEuMarket && thresholdMet
          ? {
              _free_gift: config.freeGiftName,
              _free_gift_id: config.freeGiftId,
            }
          : {
              _free_gift: '',
              _free_gift_id: '',
            };

      return updateCartAttributes(attributes);
    } catch (error) {
      console.error('Failed to sync free gift cart attributes:', error);
      return cartData;
    } finally {
      syncInProgress = false;

      if (syncQueued) {
        syncQueued = false;
        return syncCartFreeGiftAttributes();
      }
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === SYNC_SOURCE) return;
      return syncCartFreeGiftAttributes(event?.cartData);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    syncCartFreeGiftAttributes();
  });

  window.syncCartFreeGiftAttributes = syncCartFreeGiftAttributes;
})();
